// extracted by mini-css-extract-plugin
export default {"rotate":"Skill_rotate__Bgiub","text":"Skill_text__Q+PI5"};